import React from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import RequiredIndicator from "../Form/RequiredIndicator";

const TextInput = (props) => {
	const {
		name,
		type,
		label,
		touched,
		error,
		required,
		onChange,
		onBlur,
		classes,
		nullable,
		...attributes
	} = props;
	const inputId = `input-${name.replace(/\./g, "-")}`;

	const valid = required & touched && !error ? true : false;
	const invalid = required & touched && error ? true : false;
	const requiredIndicator = nullable ? false : true;

	return (
		<FormGroup>
			<Label for={inputId}>
				{label} {requiredIndicator && required && <RequiredIndicator />}
			</Label>
			<Input
				type={type}
				name={name}
				id={inputId}
				onChange={onChange}
				onBlur={onBlur}
				invalid={invalid}
				valid={valid}
				className={classes}
				{...attributes}
			/>
			{required && invalid && (
				<FormFeedback valid={valid}>{error}</FormFeedback>
			)}
		</FormGroup>
	);
};

TextInput.defaultProps = {
	placeholder: "",
	touched: false,
	error: false,
	required: false,
	maxLength: undefined,
	data: [],
};

export default TextInput;
